<template>
  <v-layout column align-center class="settings-page">
    <v-card id="user-interface" class="settings-card mx-auto mb-5" flat>
      <v-card-title class="settings-card__header">
        {{ $t('app.settings.title') }} &rsaquo; {{ $t('app.settings.user_interface.title') }}
      </v-card-title>
      <div class="settings-card__body assessment-light panel-opaque">
        <user-interface-preferences show-language></user-interface-preferences>
      </div>
    </v-card>
  </v-layout>
</template>

<script>
import UserInterfacePreferences from '@/components/widgets/UserInterfacePreferences'
import './styles/settings.css'

export default {
  name: 'UserInterface',
  components: { UserInterfacePreferences },
}
</script>
